<h3>{{ 'Shopping Basket' | translate}}</h3>
<p>{{ 'Booking-basket-date-header' | translate:{bookingDate: bookingDate, bookingDateStartTime: bookingDateStartTime,
        bookingDateEndTime:bookingDateEndTime} }}</p>
